import { render, staticRenderFns } from "./ArticleSetModal.vue?vue&type=template&id=7447bcbf&"
import script from "./ArticleSetModal.vue?vue&type=script&lang=js&"
export * from "./ArticleSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports